export default __webpack_public_path__ + "static/media/Kak_stat_ychastnikom-02.4b6fd76a.svg";